export default "__VITE_ASSET__DmJUIei6__"